import React from "react";
import { QrCode, Share2, Download } from "lucide-react";
import html2canvas from "html2canvas";

const QrCodeCard = ({ qrCode, userData }) => {
  const handleCopyLink = () => {
    const link = `${window.location.origin}/topup?user=${userData.id}`;
    navigator.clipboard.writeText(link);
    alert("Wallet link copied!");
  };

  const handleDownload = () => {
    const qrCard = document.getElementById("qr-card");
    const buttons = qrCard.querySelector(".no-download");

    // Temporarily hide buttons before capture
    buttons.style.display = "none";

    html2canvas(qrCard, { useCORS: true, scale: 2 }).then((canvas) => {
      const link = document.createElement("a");
      link.download = `${userData.name}-QR-Card.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();

      // Restore buttons after download
      buttons.style.display = "flex";
    });
  };

  if (!qrCode) {
    return (
      <div className="card shadow-lg text-center p-5 w-100" style={{ maxWidth: "420px" }}>
        <p className="text-muted mb-0">No QR code available.</p>
      </div>
    );
  }

  return (
    <div id="qr-card" className="qr-card card border-0 shadow-sm p-4 text-center mx-auto theme-card-white">
      <div className="qr-header mb-4">
        <div className="icon-wrapper mx-auto mb-2">
          <QrCode size={36} className="text-theme" />
        </div>
        <h5 className="fw-semibold theme-text-black pb-1">Payment QR Code</h5>
        <p className="text-muted text-sm mb-0 theme-text-color">Scan this QR code to send or receive payments.</p>
      </div>

      <div className="qr-image-wrapper mb-4">
        <img
          src={qrCode}
          alt="User QR Code"
          className="qr-image rounded shadow-sm"
        />
      </div>

      <div className="no-download d-flex flex-column gap-2 mt-3">
        <button onClick={handleCopyLink} className="theme-btn justify-content-center" >
          <Share2 size={18} />
          Copy Payment Link
        </button>
        <button onClick={handleDownload} className="border-btn justify-content-center">
          <Download size={18} />
          Download QR
        </button>
      </div>
    </div>
  );
};

export default QrCodeCard;
